import React from 'react';
import { useSelector } from 'react-redux';

import {
  handleChange,
  isRequired,
  getFieldKey,
  fieldShouldDisplay,
} from '../../../../utils/form';

import FormLabel from './FormLabel';

import './styles.scss';

function YesNo({
  cols = '12',
  disabled,
  name,
  unsetFieldsOnTrue = [],
  unsetFieldsOnFalse = [],
  className = '',
}) {

  const { values, form: { form } } = useSelector(store => store);
  const value = values[name];
  const required = isRequired({ form, name, currentValues: values });

  const validationRegex = useSelector(store => store.validation[name]);
  const defaultLabel = useSelector(store => store.labels[name]);

  const { submittedFlag } = useSelector(store => store.enrollment);

  const customLabel = getFieldKey(form, name, 'label');

  // if field doesn't exist, don't show it.
  if (!fieldShouldDisplay(form, name, values)) return null;

  // allow a user to unset their selection if they accidentally click
  // yes/no and don't want to populate a value.
  function unsetFieldOnSecondClick(newValue, oldValue) {
    if (newValue === oldValue) {
      handleChange({
        value: undefined,
        name,
        valid: true,
        validationRegex,
        unsetFieldsOnTrue,
        unsetFieldsOnFalse,
        required,
      });
    }
  }

  return (
    <div className={`col-md-${cols} ${className}`}>
      <FormLabel name={name} label={customLabel || defaultLabel} required={required} />
      <br />
      <button
        type="button"
        className={['yn-button me-4', (value === true && 'yn-button-hl')].join(' ')}
        onClick={() => handleChange({
          value: true,
          name,
          forceValidation: true,
          validationRegex,
          unsetFieldsOnTrue,
          unsetFieldsOnFalse,
          onChangeCallback: (newValue) => unsetFieldOnSecondClick(newValue, value),
        })}
        disabled={disabled || submittedFlag}
      >
        Yes
      </button>
      <button
        type="button"
        className={['yn-button', (value === false && 'yn-button-hl')].join(' ')}
        onClick={() => handleChange({
          value: false,
          name,
          forceValidation: true,
          validationRegex,
          unsetFieldsOnTrue,
          unsetFieldsOnFalse,
          onChangeCallback: (newValue) => unsetFieldOnSecondClick(newValue, value),
        })}
        disabled={disabled || submittedFlag}
      >
        No
      </button>
    </div>
  );
}

export default YesNo;
